module.exports = __webpack_public_path__ + "static/vitapak-88ce779fc19d6147dd4c76fa2d39b273.jpg";